import { faShieldCheck } from "@jewlr/pro-solid-svg-icons/faShieldCheck"
import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "components/ui/carousel"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { isTestMode } from "helpers/application"

const PRODUCT_REVIEWS = {
  JWE0002: [
    {
      name: "Andy",
      text: "My wife is very pleased with the earrings, just what she wanted, if she's happy I'm happy.",
    },
    {
      name: "Mary V.",
      text: "Love these earrings. Great price!",
    },
    {
      name: "Danielle A.",
      text: "Great size and setting. Love the colour.",
    },
    {
      name: "alan",
      text: "Wife loved them. The ideal birthday present. Superb.",
    },
    {
      name: "Matthew",
      text: "My wife loves them. They are even prettier in person than they are on the website. Very pleased.",
    },
    {
      name: "Amanda",
      text: "Beautiful, nice size, super sparkly",
    },
    {
      name: "Nicolaos",
      text: "Great value, made to order, perfect",
    },
    {
      name: "Joachim g.",
      text: "Perfect. Good size and very beautiful",
    },
  ],
  JWL0018: [
    {
      name: "Nick Hanson",
      text: "She loves the Ring, It's exactly what I was looking for and the whole process was easy, Thank You.",
    },
    {
      name: "Dean F.",
      text: "Very happy with purchase. Exactly what I ordered and time to delivery was fairly quick",
    },
    {
      name: "Fidel",
      text: "Got this as a gift for my girlfriend's birthday and she loves it!",
    },
  ],
  JWL0063: [
    {
      name: "Babe",
      text: "This ring is absolutely gorgeous, I love it. Thank you ☺️",
    },
    {
      name: "miles",
      text: "Perfect, as designed, and she loves it :)",
    },
    {
      name: "Channa B.",
      text: "Amazing price and the ring is phenomenal! My daughter is using it for her Senior ring and its just perfect",
    },
    {
      name: "chad",
      text: "Delivery was on time and love the ring it beautiful. Everything went well, will definetly buy Jewlr again.",
    },
  ],
  JWL0124: [
    {
      name: "Leslie",
      text: "Beautiful ring, brought it for my mom for her birthday & she loved it",
    },
    {
      name: "CAROL",
      text: "My wife designed it and we both love it. She has always wanted a Mother's ring and this is perfect!",
    },
    {
      name: "Amber C.",
      text: "This ring was amazing and my mother loved it for her birthday gift",
    },
    {
      name: "Adam",
      text: "Wife loved it. Quality craftsmanship, no flaws. Highly recommend.",
    },
    {
      name: "kayla p.",
      text: "I love this ring! I bought it for my mom and I know shes going to love it as well!",
    },
    {
      name: "Daniel",
      text: "Amazing quality! Loved it and can't wait to give it to my wife.",
    },
  ],
  JWL0133: [
    {
      name: "Marcus",
      text: "Beautiful ring. Excellent quality. She absolutely LOVED it!!!",
    },
    {
      name: "Jonathan",
      text: "Quality overall seemed pretty good. My girlfriend loved her ring and never takes it off now",
    },
    {
      name: "Elise",
      text: "Loved designing my own ring that turned out perfectly.",
    },
  ],
  JWL0205: [
    {
      name: "Preston P.",
      text: "An excellent mother's ring that my wife really loves. A great gift!",
    },
    {
      name: "Chandra",
      text: "This is a terrific way to display my kids' names and birthstones. It's exactly what I was looking for",
    },
    {
      name: "CYNTHIA",
      text: "I have always wanted a Mother's ring to honor my 4 wonderful children. I absolutely love this ring!",
    },
    {
      name: "Laci R.",
      text: "This ring turned out beautifully! Great quality.",
    },
    {
      name: "Dale",
      text: "The ring is beautiful and you can't beat the price for something that's personalized. Great mother's ring.",
    },
  ],
  JWL0246: [
    {
      name: "Gerson I.",
      text: "Beautiful ring for an amazing price. My lady is going to love it!",
    },
    {
      name: "Kaleb",
      text: "Absolutely love the ring. So glad I chose Jewlr.",
    },
    {
      name: "Brittney",
      text: "Love it! Great price. Just what I was looking for.",
    },
    {
      name: "Robert",
      text: "Short waiting period easy to customize and beautiful results!",
    },
    {
      name: "Dylan O.",
      text: "Speedy delivery, discrete package, quality product. What more could I ask for?",
    },
    {
      name: "Chris C.",
      text: "Looks just as good in person as it does on the website",
    },
  ],
  JWL0285: [
    {
      name: "Bethany T.",
      text: "Our family loved this as a gift for our Mom. It was beautiful. The website was easy to navigate and the shipping was fast and reliable. Well done.",
    },
    {
      name: "Dennis P.",
      text: "Beautiful ring with a stone for each kid and grandkid",
    },
    {
      name: "Jana",
      text: "This was a gift from my father for my mother's birthday. It was perfect. The quality of the ring was excellent, and it was delivered very quickly.",
    },
    {
      name: "Karen",
      text: "Love everything about my family ring!! Have bought a number of rings from Jewlr and have always been pleased with my purchases.",
    },
    {
      name: "Mike",
      text: "Bought this as a Grandmother's ring for my wife, from her grandkids. The stones are bright, the ring itself is well crafted and shiny.",
    },
    {
      name: "Celeste M.",
      text: "This ring represents each of our 7 grandchildren! Stones are lovely and ring fits perfect! Thank you",
    },
  ],
  JWL0296: [
    {
      name: "Brenda",
      text: "I got exactly what I asked for. It's a beautiful ring. This is my second purchase, and I love it",
    },
    {
      name: "Christina H.",
      text: "Gorgeous ring, great price and fast delivery. I couldn't be happier and will definitely order again!",
    },
    {
      name: "David",
      text: "Ring is exactly as I expected it to be. My Wife loves it. Really love all the customizable options",
    },
    {
      name: "Jayne",
      text: "Excellent quality product, great value for money and exactly what I requested. Would highly recommend!",
    },
    {
      name: "Matthew H.",
      text: "The ring turned out better than expected. My mom loves it!!",
    },
  ],
  JWL0492: [
    {
      name: "Karen",
      text: "So pretty! My daughter loved it! Designed as a mothers ring with their initials engraved inside the ring, made it extra special. Craftsmanship excellent, timely delivery. So pleased.",
    },
    {
      name: "Justine",
      text: "Beautiful ring! Well made, excellent quality, stones are a good size and feels sturdy while still looking delicate.",
    },
    {
      name: "Melissa",
      text: "I’m absolutely thrilled with this ring! The quality is beautiful, it looks even better in person, and it fits perfectly. Shipping was fast and the packaging was lovely.",
    },
  ],
  JWL0515: [
    {
      name: "Rachel H.",
      text: "I absolutely love it's delicate design, and it's meaning for me. Thank you for helping me out",
    },
    {
      name: "Jubayed",
      text: "Great craftsmanship. My girlfriend loved it",
    },
    {
      name: "Hugh",
      text: "Beautiful ring and delivered on time. Personalised engraving was perfect too.",
    },
  ],
  JWL0552: [
    {
      name: "Gabriel B.",
      text: "It's beautiful and I can't wait to give it to my girlfriend!",
    },
    {
      name: "Carol",
      text: "It was everything I hoped it would be! Gorgeous, well-made, and wonderful quality. My best friend absolutely loved it! I would definitely buy from Jewlr again.",
    },
    {
      name: "Ronald C.",
      text: "Very pleased with the ring I ordered, very pretty and excellent workmanship!! My wife will love it!",
    },
    {
      name: "Gary",
      text: "Beautiful custom ring with the birthstones of our two little ones. Not flashy, but a beautiful design and stones. Perfect gift.",
    },
  ],
  JWL0770: [
    {
      name: "Brendan R.",
      text: "Girlfriend absolutely loves it. Engraving looks great and ring seems well made. Very happy with my purchase.",
    },
    {
      name: "Richard Frederick",
      text: "Thank you so much and even received the ring early. Beautiful piece.",
    },
    {
      name: "KYLE W.",
      text: "Good price point, love how I got to choose everything for it. Looks great!",
    },
    {
      name: "Janice",
      text: "This is my second ring from Jewlr. This is a beautiful ring, can't wait to wear it.",
    },
  ],
  JWL0789: [
    {
      name: "Theresa Thomas",
      text: "I bought this for my granddaughter’s graduation and she absolutely loved it. Very good quality came well boxed. I would definitely purchase from them again.",
    },
    {
      name: "Christine l Reese",
      text: "My daughter absolutely loved it. The ring was very beutiful.",
    },
    {
      name: "Carol",
      text: "I’ve got my graduation ring with Opal gemstone and it’s incredibly beautiful! I’ll very proudly wear it every day❤️️ It’s very carefully crafted and gorgeous. It definitely worth the price!",
    },
    {
      name: "Stephanie",
      text: "We looked forever for a ring that was unique for a high school senior. This is well-made, beautiful, and unique. Worth the money!",
    },
  ],
  JWL1049: [
    {
      name: "Daria",
      text: "This ring came out so good! It’s so pretty, and the engraving was perfect! Shipping was also super quick! 10/10",
    },
    {
      name: "Keilan",
      text: "My girlfriend absolutely loves it",
    },
  ],
  JWLM0052: [
    {
      name: "Nila",
      text: "I love this ring and I believe it's something my husband will have for a long time. Thank you so much",
    },
    {
      name: "Barbara B.",
      text: "Great product, well-made, beautiful ring for a fantastic price!",
    },
    {
      name: "Norma",
      text: "My boyfriend loved his ring! Really happy with the purchase",
    },
    {
      name: "Miranda",
      text: "This is such a beautiful ring. Amazing quality. Shipped pretty fast. My fiancé and I love this ring",
    },
  ],
  JWLN0300: [
    {
      name: "Tracy Williams",
      text: "I love my piece. Well made and exactly what I thought it would be.",
    },
    {
      name: "Brandon Punch",
      text: "The necklace is beautiful and was delivered much faster than expected for a custom piece of jewelry.",
    },
    {
      name: "Ajeenah Seifudfin-ngozi",
      text: "I love my purchase I will definitely order another necklace.",
    },
    {
      name: "Isabela S.",
      text: "Very great quality. My girlfriend loved it",
    },
  ],
  "JWLN0468-3": [
    {
      name: "Christopher",
      text: "I bought this for my wife with our 3 children's names on for mothers day and she absolutely loves it",
    },
    {
      name: "Eric Dumoulin",
      text: "It was a gift for the wife. I had the kids names on it <br />and she loves it.",
    },
    {
      name: "Reymond",
      text: "My wife loved the engraved necklace. Good quality. Delivered quickly.",
    },
    {
      name: "Jacqueline",
      text: "Absolutely gorgeous necklace. I received so many compliments. It’s will be a family heirloom.",
    },
    {
      name: "Brent",
      text: "Fast turn around and shipping. Wife loves the neckless. Numerous compliments and people asking where to get one. A+",
    },
    {
      name: "Guyette",
      text: "I bought this for my daughter who just had her 3rd daughter. She is in love with it!",
    },
  ],
  "JWLN0473-1": [
    {
      name: "Craig",
      text: "Such fine craftsmanship. The quality is amazing and more than I expected. Delivery times were amazing and great communication throughout!",
    },
    {
      name: "John",
      text: "The necklace was exactly what I was looking for and it was delivered on time.",
    },
    {
      name: "Alyssa",
      text: "Very simple and cute. I got a single letter and it’s not too showy, very subtle. I love it!",
    },
    {
      name: "Alex",
      text: "Girlfriend loved it, looked great. Can’t go wrong",
    },
  ],
  JWLN0499: [
    {
      name: "Stacey",
      text: "I bought this gift for my mom for her birthday. Best surprise we got her, loved all the stones and kids names on there. She has showed it off with pride and joy.",
    },
    {
      name: "Desma",
      text: "I loved my necklace. It was very beautiful and meant a lot.",
    },
    {
      name: "Gail",
      text: "It’s a beautiful necklace for my daughter-in-law with her children’s names engraved with their birthstones!",
    },
  ],
  "JWLN0709-2": [
    {
      name: "Vinny",
      text: "Came out beautiful, both kids names! My wife loved it for Mother’s Day.",
    },
    {
      name: "denise",
      text: "Beautiful Mother’s Day gift. Elegant and simple.",
    },
    {
      name: "Eleni",
      text: "Love my 2 name neaclace. Very happy with the service and speedy delivery. I will be purchasing again!",
    },
    {
      name: "Sarah",
      text: "I love my necklace! Placing the order was easy and it looks great! I've gotten so many compliments already.",
    },
    {
      name: "G f.",
      text: "Not a single fault with the service or quality of workmanship. It’s a beautiful necklace and I love it!",
    },
    {
      name: "Heather",
      text: "Great quality and very elegant. I get lots of compliments!",
    },
  ],
  JWLN0721: [
    {
      name: "June",
      text: "My daughter loved the engraved cross necklace. Quick delivery, and the price was great.",
    },
    {
      name: "Kara",
      text: "Love this necklace! Perfect size, lays flat. I wear it all the time.",
    },
    {
      name: "Seta",
      text: "The 14k Gold chain and cross were very nice. Quality was excellent",
    },
  ],
  JWLP0179: [
    {
      name: "Laurence J.",
      text: "Beautiful necklace, my partner loved it for her birthday.",
    },
  ],
  JWLP0365: [
    {
      name: "Judy",
      text: "I purchased this necklace for my daughter's 1st Mother's day. She is absolutely thrilled with it. She wears it all the time",
    },
    {
      name: "Janice E.",
      text: "This was for an expectant new mother, she was thrilled about it and said when she saw their baby's name on the back <br />she almost cried.",
    },
    {
      name: "Sheri",
      text: "This was a gift for my daughter who had her first baby. She LOVED it!",
    },
    {
      name: "Morgan",
      text: "I love it so much. It is one of my favorite jewelry pieces I’ve ever owned. Especially since it’s about my baby boy.",
    },
    {
      name: "James",
      text: "A lovely gift for a new mom. The wife loved it and hasn’t taken it off....",
    },
    {
      name: "Anthony",
      text: "I gave this necklace to my wife after the birth of our son, and she absolutely loved it. I would definitely recommend to others.",
    },
  ],
  JWLP0507: [
    {
      name: "Christopher",
      text: "My partner really enjoyed the gift and loves the design and the stones. Best gift I've ever bought for her.",
    },
    {
      name: "Rex G.",
      text: "Beautiful necklace at a fair price. The packaging and presentation by the company was superb.",
    },
    {
      name: "David B.",
      text: "I was looking for a cute birthstone item. This was unique compared to many other offerings on the market.",
    },
    {
      name: "rum",
      text: "Really happy with the necklace more importantly my wife's happy with it. Great speedy service too",
    },
  ],
  JWLP0653: [
    {
      name: "Dustin",
      text: "The necklace looks amazing and was delivered quickly. Will order from Jewlr again.",
    },
    {
      name: "Lynn R.",
      text: "I bought a necklace with mine and my husband's birthstones. It's so pretty. I absolutely love it.",
    },
    {
      name: "Irene",
      text: "This is a beautiful pendant. My wife loved it and it looks great.",
    },
  ],
  "JWLP0653-3": [
    {
      name: "Stephanie",
      text: "My mother was pleased with her gift. It had the birth stones of her 3 children.",
    },
    {
      name: "Victoria",
      text: "Great product. Exactly as it’s advertised",
    },
    {
      name: "Cathy",
      text: "Got the 3 stone to represent mother, daughter and son.",
    },
    {
      name: "Stephen X.",
      text: "She loved the necklace. Delivery was quick and she won't stop talking about it. Thank you so much.",
    },
  ],
  JWLP0655: [
    {
      name: "Scott Z.",
      text: "Everything looked like it should and my girlfriend really liked the necklace",
    },
    {
      name: "Thomas",
      text: "Received in good condition and high quality",
    },
    {
      name: "Larry",
      text: "It’s was beautiful she loved it. Thanks",
    },
  ],
  JWLP0660: [
    {
      name: "ulises",
      text: "was great perfect gift for mothers day Mom, she loved it and said it was the best gift ever",
    },
    {
      name: "Guen",
      text: "It is beautiful! The Locket is a fair size. This was purchased for my grand-daughter as a keepsake of her and her Bis-Nonna.",
    },
    {
      name: "Teri",
      text: "The locket was beautiful, engraving nicely done. Customer service and ordering process were seamless and easy. Thank you Jewlr!",
    },
  ],
  JWLP0710: [
    {
      name: "Veronica",
      text: "This was purchased for my daughter as a gift for Mother’s Day. It is so pretty and looks beautiful. It came on time as promised. Very well pleased with the quality.",
    },
    {
      name: "Pomento",
      text: "I bought a version of this necklace as a gift… then bought another version for myself ☺️ Pretty!",
    },
    {
      name: "Jessica",
      text: "This necklace is so beautiful. I picked my husbands and my birthstones and the photos online don’t do it justice! (...) The chain is so incredibly sparkly and the birthstones are so pretty. ",
    },
  ],
  PRM0019: [
    {
      name: "Jerri",
      text: "Shipping was perfect. The ring is exactly the way I customized it. She's going to love it.",
    },
    {
      name: "Christopher",
      text: "This ring is beautiful and my fiancé loves it.",
    },
    {
      name: "George S.",
      text: "My girlfriend, now fiancé absolutely loves this ring. I have made several purchases from Jewlr, and she loved every piece of jewelry. I will definitely continue to purchase jewelry from JEWLR.",
    },
  ],
  PRM0034: [
    {
      name: "Alyssa G",
      text: "It's such a beautiful and daily ring, perfect for a person who doesn't want too flashy. Absolutely IN LOVE! Highly recommend!!!!",
    },
    {
      name: "Barbara Dream",
      text: "Beautiful exactly what i wanted. Will definitely order from this company again.",
    },
    {
      name: "Roseline",
      text: "Better than I expected! It's so pretty and very delicate, love it!",
    },
    {
      name: "Kamsinah G.",
      text: "The ring was more beautiful in person than what was shown. Also shipping was right on time.",
    },
  ],
}

const PdpReviewsCarousel = () => {
  const [emblaApi, setEmblaApi] = useState()
  const styleCode = useSelector((state) => state.choices?.style_code?.value)
  const featuredReviews = useSelector(
    (state) => state.wizard?.pdpFeaturedReviews
  )
  const reviews =
    featuredReviews && featuredReviews.length > 0
      ? featuredReviews
      : PRODUCT_REVIEWS[styleCode]

  const onSlideChange = useCallback(() => {
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-pdp-reviews-carousel-arrow",
      })
    }
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    emblaApi.on("select", onSlideChange)
    emblaApi.on("reInit", onSlideChange)

    return () => emblaApi?.off("select", onSlideChange)
  }, [emblaApi, onSlideChange])

  if (!reviews || reviews.length === 0) {
    return null
  }

  return (
    <Carousel
      className="bg-grey-5 tablet:mt-16 mt-8 flex items-center"
      description="Customer Reviews"
      disableSkip
      opts={{
        loop: true,
      }}
      setApi={setEmblaApi}
    >
      <CarouselPrevious
        alwaysShow
        className="relative inline-flex size-16 translate-x-0 translate-y-0 border-none"
        variant="primary"
      />
      <CarouselContent
        className="min-h-120 tablet:min-h-100"
        viewportClassName="flex-1"
      >
        {reviews.map((review, index) => (
          <CarouselItem
            className="flex flex-col items-center justify-center px-8 py-16"
            key={`review-${index}`}
          >
            <p
              className="text-black-print text-14 mb-12 text-center font-light leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: `&ldquo;${review.text}&rdquo;`,
              }}
            />
            <div className="flex flex-wrap items-center gap-8 leading-none">
              <span className="text-16 font-bold text-black">
                - {review.name}
              </span>
              <FontAwesomeIcon
                className="text-green-darker text-16"
                icon={faShieldCheck}
              />
              <span className="text-green-darker text-14 font-medium">
                Verified Buyer
              </span>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselNext
        alwaysShow
        className="relative inline-flex size-16 translate-x-0 translate-y-0 border-none"
        variant="primary"
      />
    </Carousel>
  )
}

export default PdpReviewsCarousel
